/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Orders.css";
import Sidebar from "../../components/sidebar/Sidebar2.js";
import Navbar from "../../components/navbar/Navbar2.js";
import Footer from "../../components/footer/Footer.js";
import DigitalProductsDataTable from "../../components/orders/DataTableTemplatingDemo/DigitalProductsDataTable.js";
import ModalAdd from "../../components/orders/model/ModelAddDigital.js";
import { serverTimestamp } from "firebase/firestore";
import { Tabs } from "antd";
import {
  Plus,
  Search,
  Calendar,
  ListOrdered,
  AlertCircle,
  Clock,
  CheckCircle2,
  Truck,
  PackageCheck,
  XCircle,
} from "lucide-react";
import {
  collection,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../../firebase.js";
import { Timestamp } from "firebase/firestore";
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { fetchOrders as fetchOrdersAction } from "../../redux/orders/orders";

function DigitalOrders() {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const search = queryParams.get("search");
  const today = queryParams.get("today");
  const status = queryParams.get("status");
  const products = useSelector((state) => state.ProductsReducer);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  useEffect(() => {
    setFilter(search);
  }, [search]);

  useEffect(() => {
    if (today == 1) {
      handleTabChange("1");
    }
    if (status) {
      setFilter2(status);
    }
  }, [status]);

  const current_timestamp = Timestamp.fromDate(new Date());
  const todayy = new Date();
  todayy.setHours(0, 0, 0, 0);
  const todayTimestamp = Timestamp.fromDate(todayy);

  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  const oneWeekAgoTimestamp = Timestamp.fromDate(oneWeekAgo);

  const oneMonthAgo = new Date();
  oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
  const oneMonthAgoTimestamp = Timestamp.fromDate(oneMonthAgo);

  const [selectedFilterDate, setSelectedFilterDate] = useState("week");

  const [endDate, setEndDate] = useState("");
  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  // const handleSearchSubmit = (event) => {
  //   event.preventDefault();
  //   setSelectedFilterDate("cstome");
  //   const targetDate = new Date(endDate);
  //   const currentDate = new Date();
  //   const timeDifference = targetDate.getTime() - currentDate.getTime();
  //   const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  //   const d = new Date();
  //   d.setDate(d.getDate() + parseInt(daysDifference));
  //   const dTimestamp = Timestamp.fromDate(d);
  //   setFilterFirebase(dTimestamp);
  //   setSelectedFilterDate("custom");
  // };

  const [data, setData] = useState([]);
  const [filterFirebase, setFilterFirebase] = useState(oneWeekAgoTimestamp);
  const [filterFirebaseStart, setFilterFirebaseStart] =
    useState(current_timestamp);
  const account = useSelector((state) => state.AccountReducer);
  const orders = useSelector((state) => state.OrdersReducer);
  const [lgShow, setLgShow] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);

  useEffect(() => {
    if (account) {
      const fetchDigitalOrders = async () => {
        try {
          const snapShot = await getDocs(
            query(
              collection(db, "orders"),
              where("user", "==", account?.user),
              where("timeStamp", "<", filterFirebaseStart),
              where("timeStamp", ">", filterFirebase),
              where("type", "==", "digitalProducts")
            )
          );
          let list = [];
          snapShot.docs.forEach((doc) => {
            list.push({ id: doc.id, ...doc.data() });
          });
          setData(
            list
              .filter((order) => order.deleted !== 1)
              .sort(function (a, b) {
                return b.timeStamp.seconds - a.timeStamp.seconds;
              })
              .map((item, index) => ({
                ...item,
                index:
                  list.filter((order) => order.deleted !== 1).length -
                  index +
                  999,
              }))
          );
        } catch (error) {
          console.log(error);
        }
      };

      fetchDigitalOrders();
    }
  }, [filterFirebase, filterFirebaseStart, account]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [pageSize, setPageSize] = useState(10);
  const [dataForm, setDataForm] = useState({
    user: account?.user,
    productId: "",
    name: "",
    phone: "",
    state: "",
    paid: "0",
    address: "",
    commune: "",
    deleveryStatus: "1",
    stopdeskDelivery: false,
    deleveryPrice: 0,
    products: [],
    deliveryPrice: 0,
    qty: "",
    total: 0,
    options: "",
    paymentType: "دفع عند الاستلام",
    timeStamp: serverTimestamp(),
  });

  useEffect(() => {
    dispatch(fetchOrdersAction(data));
  }, [data, dispatch]);

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState([]);

  const [isPageSizeOpen, setIsPageSizeOpen] = useState(false);

  const pageSizeOptions = [
    { value: 5, label: t("digitalOrders.pageSize.options.10") },
    { value: 10, label: t("digitalOrders.pageSize.options.25") },
    { value: 25, label: t("digitalOrders.pageSize.options.50") },
    { value: 50, label: t("digitalOrders.pageSize.options.100") },
  ];

  const handlePageSizeSelect = (value) => {
    setPageSize(value);
    setIsPageSizeOpen(false);
  };

  const toggleProduct = (name) => {
    setSelected((prev) =>
      prev.includes(name)
        ? prev.filter((pname) => pname !== name)
        : [...prev, name]
    );
  };
  const [filter, setFilter] = useState("");
  const [filter2, setFilter2] = useState("");

  const handleAdd = () => {
    setDataForm({
      user: account?.user,
      productId: "",
      name: "",
      phone: "",
      phone2: "",
      state: "",
      paid: "0",
      address: "",
      isValid: false,
      nameproduct: ".",
      commune: "",
      deleveryStatus: "1",
      stopdeskDelivery: false,
      products: [],
      deliveryPrice: 0,
      qty: 1,
      total: 0,
      note: "",
      options: "",
      paymentType: "دفع عند الاستلام",
      timeStamp: serverTimestamp(),
    });
    setLgShow(true);
  };

  const handleTabChange = (activeKey) => {
    switch (activeKey) {
      case "1":
        setFilterFirebase(todayTimestamp);
        setSelectedFilterDate("day");
        break;
      case "2":
        setFilterFirebase(oneWeekAgoTimestamp);
        setSelectedFilterDate("week");
        break;
      case "3":
        setFilterFirebase(oneMonthAgoTimestamp);
        setSelectedFilterDate("month");
        break;
      default:
        break;
    }
  };
  const onUpdateOrder = (updatedOrder) => {
    if (!updatedOrder) return;
    setData((prevOrders) => {
      return prevOrders.map((order) => {
        if (order.id === updatedOrder.id) {
          return { ...order, ...updatedOrder };
        }
        return order;
      });
    });
  };

  const onSave = (order) => {
    setData((prevData) => {
      if (!order?.id) {
        return prevData;
      }

      const exists = prevData.some((item) => item.id === order.id);

      if (exists) {
        return prevData.map((item) =>
          item.id === order.id ? { ...item, ...order } : item
        );
      }

      return [order, ...prevData];
    });
  };
  const filteredOrders =
    selected.length > 0
      ? orders.filter((order) =>
        order.products.some((product) => selected.includes(product.name))
      )
      : orders;
  console.log(filteredOrders);    
  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div className="px-3 dark:!bg-[#141414]" style={{ flex: 1, backgroundColor: "#fbf8fc" }}>
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white rounded-xl shadow-sm p-4 m-3 mt-6 border border-purple-100 dark:!border-[#3c3a3d] dark:!bg-[#181819]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("digitalOrders.pageTitle")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-300 mb-0 ">
                  {t("digitalOrders.pageDescription")}
                </p>
              </div>
            </div>
          </div>

          {/* Date Filter Tabs */}
          <div className="mx-3 mb-3 flex items-center justify-between">
            <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d] overflow-hidden">
              <div className="flex">
                {/* Bouton jour */}
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${selectedFilterDate === "day"
                    ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                    : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 hover:dark:bg-[#6e358c]"
                    }`}
                  onClick={() => handleTabChange("1")}
                >
                  {t("digitalOrders.dateFilters.day")}
                </button>

                {/* Bouton semaine */}
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${selectedFilterDate === "week"
                    ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                    : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 hover:dark:bg-[#6e358c]"
                    }`}
                  onClick={() => handleTabChange("2")}
                >
                  {t("digitalOrders.dateFilters.week")}
                </button>

                {/* Bouton mois */}
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${selectedFilterDate === "month"
                    ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                    : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 hover:dark:bg-[#6e358c]"
                    }`}
                  onClick={() => handleTabChange("3")}
                >
                  {t("digitalOrders.dateFilters.month")}
                </button>
              </div>
            </div>
          </div>


          {/* Status Filter Cards */}
          <div className="mx-3 mb-4 overflow-x-auto py-2 px-1">
            <div className="flex md:grid md:grid-cols-4 lg:grid-cols-8 gap-3 min-w-max md:min-w-0">
              <button
                onClick={() => setFilter2("")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${filter2 === ""
                  ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                  : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                  }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${filter2 === "" ? "bg-[#efd3ff] dark:bg-[#181919]" : "bg-[#faf1ff] dark:bg-[#181919]"
                    } flex items-center justify-center mr-3`}
                >
                  <ListOrdered
                    size={18}
                    className={`${filter2 === "" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${filter2 === "" ? "text-[#9e68ba] " : "text-gray-800 dark:!text-gray-300"
                      }`}
                  >
                    {t("digitalOrders.statusFilters.all.label")}
                  </div>
                  <div
                    className={`font-bold ${filter2 === "" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  >
                    {orders.length}
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2(0)}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${filter2 === 0
                  ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                  : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                  }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${filter2 === 0 ? "bg-[#efd3ff] dark:bg-[#181919]" : "bg-[#faf1ff] dark:bg-[#181919]"
                    } flex items-center justify-center mr-3`}
                >
                  <AlertCircle
                    size={18}
                    className={`${filter2 === 0 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${filter2 === 0 ? "text-[#9e68ba]" : "text-gray-800 dark:!text-gray-300"
                      }`}
                  >
                    {t("digitalOrders.statusFilters.new.label")}
                  </div>
                  <div
                    className={`font-bold ${filter2 === 0 ? "text-[#9e65bb]" : "text-[#9e68ba] dark:!text-gray-300"
                      }`}
                  >
                    {orders.filter((order) => order.status === 0).length}
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2(1)}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${filter2 == 1
                  ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                  : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                  }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${filter2 === 1 ? "bg-[#efd3ff] dark:bg-[#181919]" : "bg-[#faf1ff] dark:bg-[#181919]"
                    } flex items-center justify-center mr-3`}
                >
                  <Clock
                    size={18}
                    className={`${filter2 === 1 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${filter2 === 1 ? "text-[#9e68ba]" : "text-gray-800 dark:!text-gray-300"
                      }`}
                  >
                    {t("digitalOrders.statusFilters.pendingPayment.label")}
                  </div>
                  <div
                    className={`font-bold ${filter2 === 1 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  >
                    {orders.filter((order) => order.status === 1).length}
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2(2)}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${filter2 === 2
                  ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                  : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                  }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${filter2 === 2 ? "bg-[#efd3ff] dark:bg-[#181919]" : "bg-[#faf1ff] dark:bg-[#181919]"
                    } flex items-center justify-center mr-3`}
                >
                  <CheckCircle2
                    size={18}
                    className={`${filter2 === 2 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${filter2 === 2 ? "text-[#9e68ba]" : "text-gray-800 dark:!text-gray-300"
                      }`}
                  >
                    {t("digitalOrders.statusFilters.pendingConfirmation.label")}
                  </div>
                  <div
                    className={`font-bold ${filter2 === 2 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  >
                    {orders.filter((order) => order.status === 2).length}
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2(3)}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${filter2 === 3
                  ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                  : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                  }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${filter2 === 3 ? "bg-[#efd3ff] dark:bg-[#181919]" : "bg-[#faf1ff] dark:bg-[#181919]"
                    } flex items-center justify-center mr-3`}
                >
                  <Clock
                    size={18}
                    className={`${filter2 === 1 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${filter2 == 3 ? "text-[#9e68ba]" : "text-gray-800 dark:!text-gray-300"
                      }`}
                  >
                    {t("digitalOrders.statusFilters.paid.label")}
                  </div>
                  <div
                    className={`font-bold ${filter2 == 3 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  >
                    {orders.filter((order) => order.status === 3).length}
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2(4)}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${filter2 === 4
                  ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                  : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                  }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${filter2 === 4 ? "bg-[#efd3ff] dark:bg-[#181919]" : "bg-[#faf1ff] dark:bg-[#181919]"
                    } flex items-center justify-center mr-3`}
                >
                  <XCircle
                    size={18}
                    className={`${filter2 === 4 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${filter2 === 4 ? "text-[#9e68ba]" : "text-gray-800 dark:!text-gray-300"
                      }`}
                  >
                    {t("digitalOrders.statusFilters.rejected.label")}
                  </div>
                  <div
                    className={`font-bold ${filter2 === 4 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  >
                    {orders.filter((order) => order.status == 4).length}
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2(5)}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${filter2 === 5
                  ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                  : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                  }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${filter2 === 5 ? "bg-[#efd3ff] dark:bg-[#181919]" : "bg-[#faf1ff] dark:bg-[#181919]"
                    } flex items-center justify-center mr-3`}
                >
                  <PackageCheck
                    size={18}
                    className={`${filter2 === 5 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${filter2 === 5 ? "text-[#9e68ba]" : "text-gray-800 dark:!text-gray-300"
                      }`}
                  >
                    {t("digitalOrders.statusFilters.completed.label")}
                  </div>
                  <div
                    className={`font-bold ${filter2 === 5 ? "text-[#9e65bb]" : "text-[#9e68ba]"
                      }`}
                  >
                    {orders.filter((order) => order.status === 5).length}
                  </div>
                </div>
              </button>
            </div>
          </div>

          {/* Search and Filter Bar */}
          <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-4 mx-3 mb-4 border border-purple-100 dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="relative flex-grow max-w-xl">
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <Search size={16} className="text-gray-400" />
                </div>
                <input
                  type="text"
                  className="bg-gray-50 border border-gray-200 dark:!border-[#3c3a3d] text-gray-900 dark:bg-[#181919] dark:text-gray-300 text-sm rounded-lg block w-full pr-10 p-2.5 focus:outline-none focus:ring-2 focus:ring-purple-200"
                  placeholder={t("digitalOrders.search.placeholder")}
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                />
              </div>

             <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="flex items-center gap-4 w-full sm:w-auto">
                  <div className="relative">
                    {/* Main Trigger Button */}
                    <div
                      onClick={() => setIsOpen(!isOpen)}
                      className="group relative bg-gray-50 dark:bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] hover:border-[#9b59bf] text-gray-900 dark:text-gray-300 text-sm rounded-lg p-2.5 cursor-pointer min-w-[180px] transition-all duration-200 hover:shadow-sm focus:ring-2 focus:ring-purple-200"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          {/* Product Icon */}
                          <div className="w-5 h-5 bg-[#faf1ff] dark:bg-[#181919] rounded-md flex items-center justify-center">
                            <svg
                              className="w-3 h-3 text-[#9b59bf]"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V4z" />
                            </svg>
                          </div>

                          {/* Text Content */}
                          <span className="font-medium text-gray-900 dark:text-gray-300">
                            {selected.length > 0
                              ? selected.length === 1
                                ? t("digitalOrders.productFilter.singleProduct")
                                : t("digitalOrders.productFilter.multipleProducts", { count: selected.length })
                              : t("digitalOrders.productFilter.selectProducts")}
                          </span>
                        </div>

                        {/* Arrow Icon with Animation */}
                        <div
                          className={`transform transition-transform duration-200 ${isOpen ? "rotate-180" : ""
                            }`}
                        >
                          <svg
                            className="w-4 h-4 text-gray-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </div>

                      {/* Selected count badge */}
                      {selected.length > 0 && (
                        <div className="absolute -top-1 -right-1 bg-[#9b59bf] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold shadow-sm">
                          {selected.length}
                        </div>
                      )}
                    </div>

                    {/* Dropdown Menu */}
                    <div className="relative">
                      {isOpen && (
                        <>
                          {/* Backdrop for mobile */}
                          <div
                            className="fixed inset-0  bg-opacity-5 z-40 md:hidden"
                            onClick={() => setIsOpen(false)}
                          />

                          {/* Dropdown Container */}
                          <div
                            className="absolute mt-1 bg-white dark:bg-[#181919] dark:text-gray-300 border border-gray-200 dark:!border-[#3c3a3d] rounded-lg shadow-lg max-h-60 overflow-hidden w-full animate-in slide-in-from-top-1 duration-150"
                            style={{
                              zIndex: 100000,
                            }}
                          >
                            {/* Header */}
                            <div className="bg-[#faf1ff] dark:bg-[#181919] px-4 py-2.5 border-b border-purple-100 dark:!border-[#3c3a3d]">
                              <div className="flex items-center justify-between">
                                <span className="font-medium text-gray-800 dark:text-gray-300 text-sm">
                                  {t("digitalOrders.productFilter.availableProducts")}
                                </span>
                                {selected.length > 0 && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelected([]);
                                    }}
                                    className="text-xs text-[#9b59bf] hover:text-[#814a9f] font-medium transition-colors"
                                  >
                                    {t("digitalOrders.productFilter.clearAll")}
                                  </button>
                                )}
                              </div>
                            </div>

                            {/* Products List */}
                            <div
                              className="max-h-48 overflow-y-auto"
                              style={{
                                scrollbarWidth: "thin",
                                scrollbarColor: "#d8b4fe #f5f5f5",
                                zIndex: 100000,
                              }}
                            >
                              {products.map((product, index) => {
                                const isSelected = selected.includes(
                                  product.name
                                );
                                return (
                                  <label
                                    key={product.id}
                                    className={`group dark:bg-[#181919] flex items-center gap-2 px-4 py-2.5 hover:bg-[#faf1ff] dark:hover:bg-[#262526] cursor-pointer transition-colors duration-150 ${isSelected
                                      ? "bg-[#faf1ff] dark:bg-[#262526] border-r-2 border-[#9b59bf]"
                                      : ""
                                      }`}
                                  >
                                    {/* Custom Checkbox */}
                                    <div className="relative flex-shrink-0">
                                      <input
                                        type="checkbox"
                                        checked={isSelected}
                                        onChange={() =>
                                          toggleProduct(product.name)
                                        }
                                        className="sr-only"
                                      />
                                      <div
                                        className={`w-4 h-4 rounded border transition-all duration-200 flex items-center justify-center ${isSelected
                                          ? "bg-[#9b59bf] border-[#9b59bf]"
                                          : "border-gray-300 hover:border-[#9b59bf]"
                                          }`}
                                      >
                                        {isSelected && (
                                          <svg
                                            className="w-3 h-3 text-white"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                              clipRule="evenodd"
                                            />
                                          </svg>
                                        )}
                                      </div>
                                    </div>

                                    {/* Product Name */}
                                    <span
                                      className={`text-sm transition-colors ${isSelected
                                        ? "text-[#9b59bf] font-medium"
                                        : "text-gray-800 dark:text-gray-300 group-hover:text-[#9b59bf]"
                                        }`}
                                    >
                                      {product.name}
                                    </span>

                                    {/* Selection Indicator */}
                                    {isSelected && (
                                      <div className="w-1.5 h-1.5 bg-[#9b59bf] rounded-full ml-auto" />
                                    )}
                                  </label>
                                );
                              })}
                            </div>

                            {/* Empty State */}
                            {products.length === 0 && (
                              <div className="px-4 py-8 text-center text-gray-500 dark:text-gray-400">
                                <div className="w-8 h-8 mx-auto mb-2 text-gray-300">
                                  <svg fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M10 2L3 7v11a1 1 0 001 1h12a1 1 0 001-1V7l-7-5zM10 12a2 2 0 100-4 2 2 0 000 4z" />
                                  </svg>
                                </div>
                                <span className="text-sm">
                                  {t("digitalOrders.productFilter.noProducts")}
                                </span>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Sélecteur de page */}
                  <div className="relative">
                    {/* Main Trigger Button */}
                    <div
                      onClick={() => setIsPageSizeOpen(!isPageSizeOpen)}
                      className="group relative bg-gray-50 dark:bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] hover:border-[#9b59bf] text-gray-900 dark:text-gray-300 text-sm rounded-lg p-2.5 cursor-pointer min-w-[140px] transition-all duration-200 hover:shadow-sm focus:ring-2 focus:ring-purple-200"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          {/* Page Size Icon */}
                          <div className="w-5 h-5 bg-[#faf1ff] dark:bg-[#181919] rounded-md flex items-center justify-center">
                            <svg
                              className="w-3 h-3 text-[#9b59bf]"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M3 4a1 1 0 000 2h14a1 1 0 100-2H3zM3 10a1 1 0 000 2h14a1 1 0 100-2H3zM3 16a1 1 0 100 2h14a1 1 0 100-2H3z" />
                            </svg>
                          </div>

                          {/* Current Selection */}
                          <span className="font-medium text-gray-900 dark:text-gray-300">
                            {pageSizeOptions.find(
                              (option) => option.value == pageSize
                            )?.label || t("digitalOrders.pageSize.options.10")}
                          </span>
                        </div>

                        {/* Arrow Icon with Animation */}
                        <div
                          className={`transform transition-transform duration-200 ${isPageSizeOpen ? "rotate-180" : ""
                            }`}
                        >
                          <svg
                            className="w-4 h-4 text-gray-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>

                    {/* Dropdown Menu */}
                    <div className="relative">
                      {isPageSizeOpen && (
                        <>
                          {/* Backdrop for mobile */}
                          <div
                            className="fixed inset-0  bg-opacity-5 z-40 md:hidden"
                            onClick={() => setIsPageSizeOpen(false)}
                          />

                          {/* Dropdown Container */}
                          <div
                            className="absolute mt-1 bg-white dark:!bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] rounded-lg shadow-lg overflow-hidden w-full animate-in slide-in-from-top-1 duration-150"
                            style={{ zIndex: 100000 }}
                          >
                            {/* Header */}
                            <div className="bg-[#faf1ff] dark:bg-[#141414] px-4 py-2.5 border-b border-purple-100 dark:!border-[#3c3a3d]">
                              <span className="font-medium text-gray-800 dark:text-gray-300 text-sm">
                                {t("digitalOrders.pageSize.title")}
                              </span>
                            </div>

                            {/* Options List */}
                            <div className="max-h-48 overflow-y-auto">
                              {pageSizeOptions.map((option) => {
                                const isSelected = pageSize == option.value;
                                return (
                                  <button
                                    key={option.value}
                                    onClick={() =>
                                      handlePageSizeSelect(option.value)
                                    }
                                    className={`w-full group flex items-center gap-2 px-4 py-2.5 hover:bg-[#faf1ff] dark:hover:bg-[#262526] cursor-pointer transition-colors duration-150 text-right ${isSelected
                                      ? "bg-[#faf1ff] dark:!bg-[#2a2b2b] border-r-2 border-[#9b59bf]"
                                      : ""
                                      }`}
                                  >
                                    {/* Selection Indicator */}
                                    <div className="relative flex-shrink-0">
                                      <div
                                        className={`w-4 h-4 rounded-full border transition-all duration-200 flex items-center justify-center ${isSelected
                                          ? "bg-[#9b59bf] border-[#9b59bf]"
                                          : "border-gray-300 hover:border-[#9b59bf]"
                                          }`}
                                      >
                                        {isSelected && (
                                          <div className="w-2 h-2 bg-white rounded-full" />
                                        )}
                                      </div>
                                    </div>

                                    {/* Option Label */}
                                    <span
                                      className={`text-sm transition-colors ${isSelected
                                        ? "text-[#9b59bf] font-medium"
                                        : "text-gray-800 dark:text-gray-300 group-hover:text-[#9b59bf]"
                                        }`}
                                    >
                                      {option.label}
                                    </span>
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleAdd}
                  className="w-full sm:w-auto bg-[#9b59bf] hover:bg-[#814a9f] transition-colors text-white py-2 px-4 rounded-lg text-sm font-medium flex items-center justify-center"
                >
                  <Plus set="curved" size={18} />
                  <span className="hp-ml-8" style={{ marginRight: "8px" }}>
                    {t("digitalOrders.addOrder.button")}
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* Data Table */}
          <div className="mx-3 bg-white rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d] p-0 mb-6 overflow-hidden">
            {orders.length > 0 && (
              <DigitalProductsDataTable
                onUpdateOrder={onUpdateOrder}
                setLgShow={setLgShow}
                setData={setDataForm}
                pageSize={pageSize}
                filter={filter}
                orders={filteredOrders.filter((order) => {
                  if (filter2 === "") {
                    return order;
                  } else {
                    return order.status == filter2;
                  }
                  // else if (filter2 === "6") {
                  //   // إذا الفلتر هو قيد التأكيد
                  //   return (
                  //     order.deleveryStatus === "6" ||
                  //     order.deleveryStatus === "6-1" ||
                  //     order.deleveryStatus === "6-2" ||
                  //     order.deleveryStatus === "6-3"
                  //   );
                  // }
                  // else {
                  //   // أي فلتر آخر (حسب حالة التوصيل)
                  //   return order.deleveryStatus === filter2;
                  // }
                })}
              />
            )}
          </div>

          <Footer />
        </div>
      </div>

      <ModalAdd
        lgShow={lgShow}
        setLgShow={setLgShow}
        dataForm={dataForm}
        setDataForm={setDataForm}
        data={data}
        onSave={onSave}
      />
    </div>
  );
}

export default DigitalOrders;
